module.exports = __webpack_public_path__ + "img/women-pop.ee7ecf33.png";